<template>
    <div
        class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center"
    >
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img
                                src="@/assets/images/pages/lock-screen.png"
                                alt="login"
                                class="mx-auto"
                            />
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
								<div class="vx-card__title mb-8">
									<h4 class="mb-4">Verificando credenciales</h4>
									<p>Bienvenido, en un momento validaremos tu ingreso.</p>
								</div>
								<div style="height: 150px" id="div-with-loading" class="vs-con-loading__container text-center">
									<span class="text-danger text-sm">{{messageError}}</span>
								</div>
							</div>

                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import login from "@/mixins/login";

export default {
    mixins: [ login ],
    data() {
       return {
			messageError: '',
		}
    },
    methods: {
        showNotify(){
            this.$vs.notify({
                title: 'ServiForms Connect',
                text: `Ocurrio un error al validar las credenciales!`,
                color: 'warning',
                icon: 'error',
                time: 5000
            });

            this.$vs.loading.close('#div-with-loading > .con-vs-loading');
        },
        redirectonFail(){
            this.messageError = 'Serás redireccionado en unos instantes al inicio de sesión...';
            setTimeout(() => {
                this.$router.push("/pages/login");
            }, 4500);
        },
    },
    mounted() {
        this.$vs.loading({
            container: "#div-with-loading",
            scale: 2,
            type: "sound"
        });

        if (this.$route.params.token && this.$route.params.company_id) {
            this.loginSessionCheck(
                this.$route.params.token,
                this.$route.params.company_id
            );
        } else {
            this.$router.push("/pages/login");
        }
    }
};
</script>
